import { render, staticRenderFns } from "./warehouseLocations.vue?vue&type=template&id=1176ea78&scoped=true&"
import script from "./warehouseLocations.vue?vue&type=script&lang=js&"
export * from "./warehouseLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176ea78",
  null
  
)

export default component.exports